<template>
  <div class="dropdown" :data-placement="dataPlacement">
    <component
      :is="togglerTag"
      :class="['dropdown-toggle button flex items-center px-2 box ', togglerClass]"
    >
      <span class="w-5 h-5 flex items-center justify-center">
        <component :is="iconName" class="w-4 h-4" />
      </span>
      <span v-if="label" class="ml-2">{{ label }}</span>
    </component>
    <div :class="['dropdown-box', boxClass]">
      <div
        :class="[
          'dropdown-box__content dropdown-box__content-list box p-2 dark:bg-dark-6',
          contentClass,
        ]"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import dropDownMixin from '@/mixins/dropDownMixin';

export default {
  mixins: [dropDownMixin],

  props: {
    label: {
      type: String,
      default: null,
    },
    dataPlacement: {
      type: String,
      default: 'bottom-end',
    },
  },
};
</script>
